import { useEffect, useState } from "react";

const useSelectDocuments = () => {
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isDownloadAllDocs, setIsDownloadAllDocs] = useState(true);

  const updateSelectedDocs = (id, checked) => {
    setSelectedDocuments((prev) => {
      if (checked) {
        if (!prev.includes(id)) {
          return [...prev, id];
        }
        return prev;
      } else {
        return prev.filter((item) => item !== id);
      }
    });
  };

  useEffect(() => {
    setIsDownloadAllDocs(selectedDocuments.length === 0);
  }, [selectedDocuments]);

  return {
    updateSelectedDocs,
    isDownloadAllDocs,
    selectedDocuments,
  };
};

export default useSelectDocuments;
